import type { ReactNode } from "react";
import { InfoField } from "../InfoField";

interface EventEvolutionFieldProps {
  label: string;
  value?: ReactNode;
  strong?: boolean;
  tooltip?: string;
  tone?: "default" | "danger" | "muted";
}

export const EventEvolutionField = (props: EventEvolutionFieldProps) => (
  <InfoField {...props} fillHeight={false} strongClassName="text-lg" />
);
